import { createElement, PropsWithChildren } from "react";
import styles from "./SectionContainer.module.scss";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
import useWhitelabel from "hooks/useWhitelabel";

type SectionContainerProps = PropsWithChildren & {
  title: any;
  count?: number | string;
  className?: string;
  id?: string;
  isDesktop?: boolean;
  dataTestId?: string;
  titleClassName?: string;
  showTitleLine?: boolean;
  isPriceTrendSection?: boolean;
  contentClassName?: string;
  headingLevel?: 2 | 3 | 4 | 5 | 6;
};

const SectionContainer = ({
  title,
  count,
  children,
  className,
  id = "",
  isDesktop = false,
  dataTestId,
  titleClassName = "",
  showTitleLine = false,
  isPriceTrendSection = false,
  contentClassName = "",
  headingLevel = 4,
}: SectionContainerProps) => {
  const withCount = Boolean(count && Number(count) > 0);
  const { t } = useTranslationHook();
  const { isWhitelabel } = useWhitelabel();

  const HeadingTag = `h${headingLevel}` as const;

  return (
    <section
      className={formatClassNames(className)}
      data-testid={dataTestId}
      id={id}
      style={isPriceTrendSection && isDesktop ? { marginBottom: "16px" } : {}}
    >
      {title &&
        createElement(
          HeadingTag,
          {
            className: formatClassNames(
              isWhitelabel ? "wl-title-font" : "",
              styles.title,
              isDesktop ? styles.titleDesktop : "",
              titleClassName,
              showTitleLine && styles.titleLine,
            ),
          },
          <span>
            {typeof title !== "string" ? (
              <>
                {title} {withCount && <>({count})</>}
              </>
            ) : (
              <>
                {t(title)} {withCount && <>({count})</>}
              </>
            )}
          </span>,
        )}
      <div className={contentClassName}>{children}</div>
    </section>
  );
};

export default wrapperHOC(SectionContainer, {
  componentName: "SectionContainer-PropertyPage",
  showForChina: true,
});
